"use client";
import { Avatar, Box, Flex, RadioCards, Text } from "@radix-ui/themes";

export type RadioCardGroupProps = {
  options?: {
    label: string;
    value: string;
    sublabel?: string;
    image?: string;
  }[];
  name: string;
  value?: string;
  onChange?: (value: string) => void;
};

const RadioCardGroup = ({
  options,
  name,
  value,
  onChange,
}: RadioCardGroupProps) => {
  if (!options) return null;
  return (
    <Box width="100%">
      <RadioCards.Root
        // defaultValue="1"
        size="3"
        columns={{ initial: "1", sm: "3" }}
        variant="classic"
        color="violet"
        name={name}
      >
        {options.map((option, index) => (
          <RadioCards.Item
            key={index}
            value={option.value}
            onClick={() => onChange && onChange(option.value)}
          >
            <Flex
              direction="row"
              width="100%"
              gap="3"
              align="center"
              className="max-w-md"
            >
              <Avatar
                size="3"
                src={option.image}
                radius={option.image ? "none" : "full"}
                fallback={option.label[0]}
              />
              <Box>
                <Text size="2" weight="bold" as="div">
                  {option.label}
                </Text>
                {option.sublabel && (
                  <Text size="2" color="gray" as="div">
                    {option.sublabel}
                  </Text>
                )}
              </Box>
            </Flex>
          </RadioCards.Item>
        ))}
      </RadioCards.Root>
    </Box>
  );
};

export default RadioCardGroup;
